import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { HeaderModalOptions } from 'coreOld/constants';

interface IState {
  openedAuthModal: HeaderModalOptions | null;
  parentAuthModal: HeaderModalOptions | null;
}

const initialState: IState = {
  openedAuthModal: null,
  parentAuthModal: null,
};

const authModalSlice = createSlice({
  name: 'authModal',
  initialState,
  reducers: {
    setOpenedAuthModal: (state, action: PayloadAction<HeaderModalOptions | null>) => {
      state.openedAuthModal = action.payload;
    },
    setParentAuthModal: (state, action: PayloadAction<HeaderModalOptions | null>) => {
      state.parentAuthModal = action.payload;
    },
  },
});

export const { setOpenedAuthModal, setParentAuthModal } = authModalSlice.actions;

export const authModalReducer = authModalSlice.reducer;
